import { render, staticRenderFns } from "./clos-des-papes.vue?vue&type=template&id=4e5e3336&scoped=true"
import script from "./clos-des-papes.vue?vue&type=script&lang=js"
export * from "./clos-des-papes.vue?vue&type=script&lang=js"
import style0 from "./clos-des-papes.vue?vue&type=style&index=0&id=4e5e3336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e3336",
  null
  
)

export default component.exports